(function() {
  const initializedCarousels = new WeakMap();

  function initCarousel(carouselElement) {
    if (!carouselElement) return;
    
    // Skip if already initialized
    if (initializedCarousels.has(carouselElement)) return;

    if (typeof EmblaCarousel === 'undefined') {
      setTimeout(() => initCarousel(carouselElement), 100);
      return;
    }

    const getSlidesToScroll = () => {
      return window.matchMedia('(min-width: 768px)').matches ? 1 : 2;
    };

    const currentSlidesToScroll = getSlidesToScroll();
    const embla = EmblaCarousel(carouselElement, {
      loop: false,
      align: 'start',
      containScroll: 'trimSnaps',
      slidesToScroll: currentSlidesToScroll,
      dragFree: false
    });

    initializedCarousels.set(carouselElement, { embla, slidesToScroll: currentSlidesToScroll });

    const prevButton = carouselElement.closest('.nf-photo-gallery')?.querySelector('.nf-photo-gallery__button--prev');
    const nextButton = carouselElement.closest('.nf-photo-gallery')?.querySelector('.nf-photo-gallery__button--next');
    const dotsContainer = carouselElement.closest('.nf-photo-gallery')?.querySelector('.nf-photo-gallery__dots');
    const slides = carouselElement.querySelectorAll('.nf-photo-gallery__slide');

    const setupDots = () => {
      if (!dotsContainer) return;
      
      dotsContainer.innerHTML = '';
      slides.forEach((_, index) => {
        const dot = document.createElement('button');
        dot.className = 'nf-photo-gallery__dot';
        dot.setAttribute('type', 'button');
        dot.setAttribute('aria-label', `Go to slide ${index + 1}`);
        dot.addEventListener('click', () => embla.scrollTo(index));
        dotsContainer.appendChild(dot);
      });
    };

    const updateDots = () => {
      const selectedIndex = embla.selectedScrollSnap();
      const dots = dotsContainer?.querySelectorAll('.nf-photo-gallery__dot');
      dots?.forEach((dot, index) => {
        if (index === selectedIndex) {
          dot.classList.add('nf-photo-gallery__dot--active');
        } else {
          dot.classList.remove('nf-photo-gallery__dot--active');
        }
      });
    };

    const updateButtons = () => {
      if (prevButton) {
        prevButton.disabled = !embla.canScrollPrev();
      }
      if (nextButton) {
        nextButton.disabled = !embla.canScrollNext();
      }
    };

    if (prevButton) {
      prevButton.addEventListener('click', () => embla.scrollPrev());
    }

    if (nextButton) {
      nextButton.addEventListener('click', () => embla.scrollNext());
    }

    embla.on('select', () => {
      updateDots();
      updateButtons();
    });

    embla.on('init', () => {
      setupDots();
      updateDots();
      updateButtons();
    });

    embla.on('reInit', () => {
      const newSlidesToScroll = getSlidesToScroll();
      if (newSlidesToScroll !== currentSlidesToScroll) {
        const carouselData = initializedCarousels.get(carouselElement);
        if (carouselData?.embla) {
          carouselData.embla.destroy();
          initializedCarousels.delete(carouselElement);
          initCarousel(carouselElement);
          return;
        }
      }
      setupDots();
      updateDots();
      updateButtons();
    });

    // Handle window resize
    let resizeTimeout;
    const handleResize = () => {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(() => {
        const carouselData = initializedCarousels.get(carouselElement);
        if (carouselData?.embla) {
          const newSlidesToScroll = getSlidesToScroll();
          if (newSlidesToScroll !== carouselData.slidesToScroll) {
            carouselData.embla.reInit();
          }
        }
      }, 250);
    };

    window.addEventListener('resize', handleResize);

    setupDots();
    updateDots();
    updateButtons();
  }

  function initAllCarousels() {
    const carousels = document.querySelectorAll('.nf-photo-gallery__viewport:not([data-initialized])');
    carousels.forEach((carousel) => {
      carousel.setAttribute('data-initialized', 'true');
      initCarousel(carousel);
    });
  }

  function handleThemeEditorUpdates() {
    // Listen for theme editor DOM updates
    if (window.Shopify?.designMode) {
      document.addEventListener('shopify:section:load', initAllCarousels);
      document.addEventListener('shopify:section:reorder', initAllCarousels);
      document.addEventListener('shopify:block:select', initAllCarousels);
    }
  }

  // Initial load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      initAllCarousels();
      handleThemeEditorUpdates();
    });
  } else {
    initAllCarousels();
    handleThemeEditorUpdates();
  }

  // Use MutationObserver for theme editor updates
  if (window.Shopify?.designMode) {
    const observer = new MutationObserver(() => {
      initAllCarousels();
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }
})();

